'use client';

import React, { useEffect } from 'react';

const TrustedForm: React.FC = () => {
  useEffect(() => {
    if (
      !window.document.querySelector(
        'script[src*="trustedform.com/trustedform.js"]'
      )
    ) {
      const tfScript = window.document.createElement('script');
      tfScript.type = 'text/javascript';
      tfScript.async = true;
      tfScript.src = `${
        window.document.location.protocol === 'https:' ? 'https' : 'http'
      }://api.trustedform.com/trustedform.js?field=xxTrustedFormCertUrl&l=${
        new Date().getTime() + Math.random()
      }`;
      window.document.body.appendChild(tfScript);
    }
  }, []);

  return null;
};

export default TrustedForm;
